<template>
  <div class="w-full flex flex-col gap-1">
    <span class="text-blue-700 text-left text-xs font-semibold leading-none">
      {{ percentage }}%
    </span>
    <div class="h-2 bg-slate-100 rounded-[100px] relative w-full">
      <div
        class="h-2 bg-blue_primary rounded-[10px] absolute top-0 left-0"
        :style="{ width: percentage + '%' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percentage: { type: Number, default: 0 },
  },
};
</script>
